import { useEffect, useState } from 'react'
import { FeatureToggle } from '../../constants/FeatureToggles'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { resolveInTime } from '../resolveInTime'

export function useFeature(
  featureToggle: FeatureToggle,
  currentCompanyStore: CurrentCompanyStore | undefined,
) {
  const [featureIsEnabled, setFeatureIsEnabled] = useState<boolean | null>(null)

  useEffect(() => {
    async function getFeatureFlag() {
      await resolveInTime(currentCompanyStore?.isFeatureEnabled(featureToggle), 3000).then(
        (_featureIsEnabled) => {
          setFeatureIsEnabled(!!_featureIsEnabled)
          if (_featureIsEnabled == null) {
            throw new Error(
              'The timeout exceeded while trying to fetch the FeatureToggle flag from the API.',
            )
          }
        },
      )
    }
    getFeatureFlag()
  }, [])

  return featureIsEnabled
}
